<template>
    <div class="trading-desk-container">
        <v-layout column wrap fill-height>
            <div class="collections-container">
                <div class="buysell-wrapper thankyou-wrapper">
                    <div class="thankyou-img"></div>
                    <div>
                        <h2>Thank you for your purchase!</h2>
                        <div class="btn-primary" v-on:click="$router.push(localePath({ path: '/my-account'}))">Go to my portfolio</div>
                    </div>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "SuccessBuyFullScreen",
        head() {
            return {
                title: 'Successful purchase on the market | Fine Wine Trading App',
                meta: [
                    {
                        hid: 'description',
                        name: 'description',
                        content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                    },
                    {
                        hid: 'robots',
                        name: 'robots',
                        content: 'noindex'
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .trading-desk-container h2 {
        color: #707070;
    }

    .buysell-wrapper {
        padding: 100px calc(3 * var(--gutter));
        height: 100%;
    }

    .buysell-wrapper h2:hover {
        cursor: pointer;
        color: var(--brand);
    }

    .thankyou-img {
        background: url('../assets/v_dark.svg') no-repeat center;
        background-size: contain;
        width: 270px;
        height: 250px;
        margin: 0 auto;
    }

    .thankyou-wrapper {
        text-align: center;
    }

    .thankyou-wrapper .btn-primary {
        margin: 48px 0 32px;
    }

    @media (max-width: 767px) {
        .buysell-wrapper {
            padding-right: 15px;
            padding-left: 15px;
        }

        .trading-desk-container h2 {
            font-size: 20px;
            line-height: 22px;
        }
    }
</style>
